import { render, staticRenderFns } from "./CotPuaEditComponent.vue?vue&type=template&id=3fb2f33a"
import script from "./CotPuaEditComponent.vue?vue&type=script&lang=js"
export * from "./CotPuaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports